{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Выберите элемент",
  "tableResizer": "Средство изменения размера",
  "colorSwatchPicker": "Color swatches"
}
